import { render, staticRenderFns } from "./mobile-sheet.vue?vue&type=template&id=1fba1e94&scoped=true"
import script from "./mobile-sheet.vue?vue&type=script&lang=ts"
export * from "./mobile-sheet.vue?vue&type=script&lang=ts"
import style0 from "./mobile-sheet.vue?vue&type=style&index=0&id=1fba1e94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fba1e94",
  null
  
)

export default component.exports